<template>
  <div class="app-container">
    <navigation></navigation>
    <div class="content">
      <div class="notice" v-if="noticeList.length>0">
        <van-cell is-link to="notice" center>
          <template #title>
            <span class="module-title">最新公告</span>
          </template>
          <template #right-icon>
            <div class="more-parent">
              <span class="more-val">更多</span>
            </div>
          </template>
        </van-cell>
        <van-cell-group>
          <van-cell v-for="(item,index) in noticeList" :to="{name:'newsDetail', query: {id:item.id,title:'公告详情'}}">
            <template #title>
              <div class="message-tit">{{ item.title }}</div>
              <div class="message-tit message-tit-right" v-if="item.subTitle">{{ item.subTitle }}</div>
            </template>
            <template #label>
              <div class="time">
                <img src="@/assets/img/list-news.png" alt="" class="news" v-if="index===0">
                <span class="news-time">{{ item.startTime }}</span>
              </div>
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="notice collect" v-if="newsList.length>0">
        <van-cell is-link to="news" center>
          <template #title>
            <span class="module-title">国图新闻</span>
          </template>
          <template #right-icon>
            <div class="more-parent">
              <span class="more-val">更多</span>
            </div>
          </template>
        </van-cell>
        <van-cell-group>
          <van-cell v-for="(item,index) in newsList" :to="{name:'newsDetail', query: {id:item.id,title:'新闻详情'}}">
            <template #title>
              <div class="message-tit">{{ item.title }}</div>
              <div class="message-tit message-tit-right" v-if="item.subTitle">{{ item.subTitle }}</div>
            </template>
            <template #label>
              <div class="time">
                <img src="@/assets/img/list-news.png" alt="" class="news" v-if="index===0">
                <span>{{ item.startTime }}</span>
              </div>
            </template>
            <template #right-icon>
              <img v-if="item.coverPath" :src="baseUrl+item.coverPath" alt="" class="list-right-img">
              <img v-else :src="item.suprizeImg" alt="" class="list-right-img">
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="notice collect"  v-if="solicitationList.length>0">
        <van-cell is-link to="solicitation" center>
          <template #title>
            <span class="module-title">征集/启事</span>
          </template>
          <template #right-icon>
            <div class="more-parent">
              <span class="more-val">更多</span>
            </div>
          </template>
        </van-cell>
        <van-cell-group>
          <van-cell v-for="(item,index) in solicitationList" :to="{name:'newsDetail', query: {id:item.id,title:'征集/启事详情'}}">
            <template #title>
              <div class="message-tit">{{ item.title }}</div>
              <div class="message-tit message-tit-right" v-if="item.subTitle">{{ item.subTitle }}</div>
            </template>
            <template #label>
              <div class="time">
                <img src="@/assets/img/list-news.png" alt="" class="news" v-if="index===0">
                <span class="news-time">{{ item.startTime }}</span>
              </div>
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="notice collect bookRecommend" v-if="bookRecommendList.length>0 && bookRecommendShow">
        <van-cell is-link to="bookRecommend" center>
          <template #title>
            <span class="module-title">书刊推介</span>
          </template>
          <template #right-icon>
            <div class="more-parent">
              <span class="more-val">更多</span>
            </div>
          </template>
        </van-cell>
        <div class="book-box">
          <div class="list-box">
            <ul class="list" @scroll="scroll" ref="list">
              <li v-for="item in bookRecommendList">
                <img :src="baseUrl+item.coverPath" alt="">
                <span> {{ item.title }} </span>
              </li>
            </ul>
          </div>
          <div class="scroll-bar" ref="scrollBar">
            <div class="bar" ref="bar"></div>
          </div>
        </div>
      </div>
    </div>
    <scroll></scroll>
    <van-tabbar v-model="active" class="information-tab" ref="tab">
      <van-tabbar-item to="/">
        <span>首页</span>
        <template #icon="props">
          <span class="tabbar-bg"></span>
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="resource">
        <span>资源</span>
        <template #icon="props">
          <span class="tabbar-bg"></span>
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="information">
        <span>资讯</span>
        <template #icon="props">
          <span class="tabbar-bg"></span>
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="personal">
        <span>个人中心</span>
        <template #icon="props">
          <span class="tabbar-bg"></span>
        </template>
      </van-tabbar-item>
    </van-tabbar>
    <version></version>
  </div>
</template>

<script>
import { request } from '../../untils/request'
import navigation from '../../components/navigation'
import scroll from '../../components/scroll'
import Vue from 'vue'
import { Tabbar, TabbarItem, NavBar, Cell, CellGroup } from 'vant'
import {parseTime} from '../../untils/formatTime'
import version from '../../components/version'

Vue.use(Tabbar).use(TabbarItem).use(NavBar).use(Cell).use(CellGroup)

export default {
  name: 'information',
  components: {navigation,scroll,version},
  data () {
    return {
      baseUrl: process.env.API_ROOT,
      active: 2,
      params: {
        pageNum: '1',
        pageSize: '3'
      },
      noticeList: [],
      newsList: [],
      solicitationList: [],
      bookRecommendList: [],
      bookRecommendShow: true,
      newsUrl:[
        require('@/assets/img/news-img.png'),
        require("@/assets/img/news-img1.png"),
        require("@/assets/img/news-img2.png"),
        require("@/assets/img/news-img3.png"),
        require("@/assets/img/news-img4.png")
      ]
    }
  },
  created () {
    // 最新公告
    this.getNoticeList()
    // 国图新闻
    this.getNewsList()
    // 征集启事
    this.getSolicitationList()
    // 书刊推介
    this.getBookRecommend()
  },
  mounted() {
    this.isIPhoneX()
  },
  methods: {
    // 获取滚动条距离
    scroll  (event) {
      let barSCrollWidth = this.$refs.scrollBar.clientWidth - this.$refs.bar.clientWidth // 自定义滑条可移动范围
      let left = event.target.scrollLeft * barSCrollWidth / this.$refs.list.scrollWidth/2
      if(left > 86){
        this.$refs.bar.style.marginLeft = `${86}%`
      } else if(left < 0){
        this.$refs.bar.style.marginLeft = `${0}%`
      } else {
        this.$refs.bar.style.marginLeft = `${left}%`
      }
    },
    // 最新公告
    getNoticeList () {
      this.params.type = 'INFORMATION_NOTICE'
      request('get', '/nlc-web/api/information', this.params).then(res => {
        console.log('最新公告', res)
        for (var i = 0; i < res.data.content.length; i++) {
          res.data.content[i].startTime = parseTime(res.data.content[i].startTime,'{y}-{m}-{d}')
          let index = Math.floor(Math.random() * 4)
          res.data.content[i].suprizeImg = this.newsUrl[index]
        }
        this.noticeList = res.data.content
      })
    },
    // 国图新闻
    getNewsList () {
      this.params.type = 'INFORMATION_NEWS'
      request('get', '/nlc-web/api/information', this.params).then(res => {
        console.log('国图新闻', res)
        for (var i = 0; i < res.data.content.length; i++) {
          let index = Math.floor(Math.random() * 4)
          res.data.content[i].suprizeImg = this.newsUrl[index]
          res.data.content[i].startTime = parseTime(res.data.content[i].startTime,'{y}-{m}-{d}')
        }
        this.newsList = res.data.content
      })
    },
    // 征集启事
    getSolicitationList () {
      this.params.type = 'INFORMATION_SOLICITATION'
      request('get', '/nlc-web/api/information', this.params).then(res => {
        console.log('征集启事', res)
        for (var i = 0; i < res.data.content.length; i++) {
          res.data.content[i].startTime = parseTime(res.data.content[i].startTime,'{y}-{m}-{d}')
        }
        this.solicitationList = res.data.content
      })
    },
    // 书刊推介
    getBookRecommend () {
      var params = {
        pageNum: '1',
        pageSize: '8'
      }
      request('get', '/nlc-web/api/bookRecommend', params).then(res => {
        console.log('书刊推介', res)
        this.bookRecommendShow = res.show
        this.bookRecommendList = res.data.content
      })
    },
    // 判断手机是否为iphonex
    isIPhoneX() {
      let u = navigator.userAgent;
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        if (screen.height >= 812) {
          //是iphoneX
          console.log('this.$refs.tab.style',this.$refs.tab)
          this.$refs.tab.$el.style.paddingBottom = `${.2}rem`
        }
      }
    }
  }
}
</script>

<style scoped>
.app-container{
  background:#ecf5fd;
  padding-bottom:1.3rem;
  overflow-y:scroll;
}
.content{
  width: 6.94rem;
  margin:1.24rem .28rem 0 .28rem;
}
.notice{
  border-radius:8px;
  background:#fff;
  padding-bottom:.2rem;
}
.van-cell {
  padding:.14rem .3rem;
  border-radius:8px;
}
.van-cell--clickable{
  padding:.4rem .3rem 0 .3rem;
  border-radius:16px;
}
.van-cell--clickable::after{
  border:0 !important;
}
.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
  border-width: 0;
}
.time{
  border-bottom:1px solid #DCE5ED;
  vertical-align: middle;
}
.time span{
  vertical-align: middle;
  font-size:.26rem;
  line-height:.33rem;
  font-family: -apple-system,BlinkMacSystemFont,'Helvetica Neue',Helvetica,Segoe UI,Arial,Roboto,'PingFang SC',miui,'Hiragino Sans GB','Microsoft Yahei',sans-serif;
}
.van-cell-group{
  border-radius:8px;
}
.van-cell-group:last-child .time{
  border-bottom:0;
}
.collect{
  margin-top:.16rem;
}
.list{
  margin:.25rem 0 0 0;
  display:flex;
  font-size:.28rem;
  color:#444649;
  font-family: SourceHanSerifCN-Regular;
  overflow-x:scroll;
}
.list li{
  width:2rem;
  height:3.8rem;
  flex:1;
  margin:0 .25rem;
  text-align:center;
}
.list li:first-child{
  margin-left:0;
}
.list li:last-child{
  margin-right:0;
}
.list li img{
  width:1.7rem;
  height:2.4rem;
  box-shadow: 6px 4px 10px -6px #000;
  margin-bottom:.11rem;
}
.list li span{
  display:block;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.more-val{
  width:.66rem;
  display:inline-block;
  font-size:.24rem;
  font-family: SourceHanSansCN-Regular;
  line-height: .24rem;
  vertical-align: middle;
}
.module-title{
  font-size:.36rem;
  font-weight:bold;
  font-family: SourceHanSerifCN-SemiBold;
}
.van-cell::after{
  border-bottom: 1px solid #B3BBC3;
}
>>>.van-tabbar-item__icon img{
  width:.56rem;
  height:.56rem;
}
>>>.van-tabbar-item__text{
  font-size:.2rem;
}
>>>.van-tabbar{
  height:1.1rem;
}
.top{
  width:.24rem;
  height:.25rem;
  vertical-align: middle;
}
.news{
  width:.45rem;
  height:.25rem;
  vertical-align: middle;
}
.list-right-img{
  width:1.92rem;
  height:1.42rem;
  border-radius:8px;
}
.van-cell__title{
  width:70%;
  font-family: SourceHanSerifCN-Regular;
  color:#444649;
  font-size:.3rem;
  line-height:.4rem;
}
.more-parent{
  display: inline-block;
  vertical-align: middle;
}
.tabbar-bg{
  width:.56rem;
  height:.56rem;
  display:inline-block;
}
>>>.van-tabbar-item__text{
  font-size:.2rem;
  font-family: SourceHanSerifCN-Medium;
}
.list-box {
  width:6.3rem;
  height:3.9rem;
  overflow:hidden;
  margin:0 .32rem;
}
.scroll-bar {
  width:6.2rem;
  height:.08rem;
  background: #E6EFF7;
  border-radius: 8px;
  margin-left:.37rem;
}
.bar{
  width:.88rem;
  height:.08rem;
  border-radius: 8px;
}
.message-tit{
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  word-wrap:break-word;
  padding-right:.1rem;
}
.news-time{
  float: right;
}
.message-tit-right{
  text-align:right;
}
</style>



// WEBPACK FOOTER //
// src/view/information/index.vue